<template>
    <div v-if="pack">
        <div v-if="!pack.style_id" class="text-center font-weight-bold">
            <div class="card mb-4 box-shadow">
                <div class="card-header">
                    <h4 class="my-0 font-weight-normal">{{pack.name}}</h4>
                </div>
                <div class="card-body">
                    <h1 class="card-title pricing-card-title">
                        <del v-if="pack.price > 0">${{pack.default_price}}</del>
                        ${{pack.price ? pack.price : pack.default_price}}
                    </h1>
                    <small class="font-weight-bold">{{pack.description}}</small>
                    <div class="border-top pt-2" style="margin:auto;">
                        <div class="mb-2" v-for="award in pack.awards">
                            <div v-if="award.value">
                                <img :title="award.text" :src='`/images/`+award.icon' class="icon24" /> {{$helpers.prettyNumber(award.value)}} {{award.text}}
                            </div>
                        </div>
                        <div class="w-100">
                            <div class="small">* If you already have VIP, the duration will be extended.</div>
                            <div class="small">* Prices are in USD</div>
                        </div>
                    </div>
                    <div v-if="pack.token==='VIP'" class="text-center">
                        <b-button variant="outline-success" class="small mt-2"
                                v-b-popover.hover.html.bottom="{ variant: 'info',  content: '- Personal badge <br> - Access to VIP room <br> - Longer dig duration <br> - 6 Daily card draws <br> - Daily mysterious chests <br> - Increased chance when digging' }"
                                title="VIP Benefits">
                            What is VIP?
                        </b-button>
                    </div>
                    <div class="mt-2">
                        <a v-if="false" :href="'/purchase_request?method=credit-card&pack='+pack.token" 
                        style="box-shadow: 1px 1px #d1d1da;background:#d9e1fb;width:190px;display:inline-block;text-decoration:none" class="border rounded mt-2" target="_blank">
                            <img style="width:42px;" src="/images/payment/visa.jpg" />
                            <img style="width:42px;" src="/images/payment/mc.png" />
                            <img style="width:42px;" src="/images/payment/discover.png" />
                        </a>
                        <a :href="'/purchase_request?method=paypal&pack='+pack.token" style="" target="_blank">
                            <img src="/images/payment/paypal.png" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div :class="{
                'style-1': pack.style_id === 1, 
                'style-2': pack.style_id === 2, 
                'style-3': pack.style_id === 3,
                'style-5': pack.style_id === 5,
                }" class="holder" v-bind:style="{ backgroundImage: 'url(images/store/' + pack.bg_img + ')' }" >
                <div class="time" v-if="dateDiff">
                    <img src="/images/store/clock.png" /> {{ dateDiff }}
                </div>
                <div class="time" v-else-if="pack.purchase_limit">
                    <img src="/images/store/clock.png" /> Limit: 0/{{ pack.purchase_limit }}
                </div>
                <div class="title">
                    <h2 class="">{{pack.name}}</h2>
                    <div class="price">
                        <del v-if="pack.price">${{pack.default_price}}</del>
                        <span class="final-price">${{pack.price ? pack.price : pack.default_price}}</span>
                    </div>
                </div>
                <div class="row awards">
                    <div :class="{'col l': pack.style_id !== 5, 'col-12': pack.style_id === 5}">
                        <div class="row">
                            <template v-for="(award, i) in pack.awards">
                                <div class="mb-1 col-6 award" v-if="i % 2 === 0">
                                    <div class="window">
                                        <img class="award-icon" :title="award.text" :src='`/images/`+award.icon' /> 
                                    </div>
                                    <div class="txt-container">
                                        <div class="txt">
                                            {{$helpers.prettyNumber(award.value)}} {{award.text}}
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div v-if="pack.style_id === 3" class="col">
                    </div>
                    <div :class="{'col r': pack.style_id !== 5, 'col-12': pack.style_id === 5}">
                        <div class="row">
                            <template v-for="(award, i) in pack.awards">
                                <div class="mb-1 col-6 award"  v-if="i % 2 !== 0">
                                    <div class="window">
                                        <img class="award-icon" :title="award.text" :src='`/images/`+award.icon' /> 
                                    </div>
                                    <div class="txt-container">
                                        <div class="txt">
                                            {{$helpers.prettyNumber(award.value)}} {{award.text}}
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="col-12 text-center"></div>
                    <div class="col-12 mt-1 text-center button-holder">
                        <a v-if="source === 'never'" target="_blank" href="\packages" class="chk-btn2 mt-2">Go To Store</a>
                        <a v-else target="_blank" :href="'/purchase_request?method=paypal&pack='+pack.token"><img class="chk-btn mt-2" src="/images/payment/paypal.png" /></a>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        data() {
            return {
                
            }
        },
        props: ["pack", "source"],
        computed: {
            dateDiff(){
                if(!this.pack || !this.pack.ends_at) return null;
                var m1 = moment();
                var m2 = moment(this.pack.ends_at);
                var m3 = m2.diff(m1,'minutes');
                var numdays = Math.floor(m3 / 1440);
                var numhours = Math.floor((m3 % 1440) / 60);
                var numminutes = Math.floor((m3 % 1440) % 60);
                let daytxt = numdays + 'd ';
                return daytxt + numhours +"h " + numminutes +"m";
            },
        },
        components: {

        },
        methods: {
            isExpired(pack){
                if(typeof pack.ends_at === "undefined" || pack.ends_at === null)
                    return false;
                if(moment(pack.ends_at).isSameOrAfter(moment())){
                    return false;
                }
                return true;
            }
        },
        mounted: function () {
            this.$http.get("/purchase_packs").then((res) => {
                this.packs = res.data
            });
        }
    }
</script>
<style scoped>


.final-price{
    vertical-align: middle;
}
.time{
    display:block;
    position: absolute;
    left:10px;
    top:6%;
    color:#ffff66d9;
}
.time img {
    vertical-align: sub;
}
.price{
    color: #fffe00;
    margin-left: 10px;
    font-size: 2.5rem;
    display: inline;
    font-weight:bold;
}
.title{
    position: absolute;
    text-align: center;
    width:100%;
}
.title h2{
    font-weight: bold;
    color: #fff;
    font-family: arial;
    margin-top: 0.5rem;
    display: inline;
}
.chk-btn{
    width:238.4px;
}

.chk-btn2{
    text-align: center;
    color:#000;
    font-weight: bold;
    padding-top: 7px;
    font-family: sans;
    width:298px;
    height:56px;
    display: block;
    margin: auto;
    background-image: url(/images/store/button.png);
}
.holder{
    margin:auto;
    background-position: bottom;
    background-size: cover;
    position:relative;
    max-width: 1200px;
}
.style-5{
    aspect-ratio: 1200/590;
}


.style-5 .title{
    height: 14%;
    width:75%;
    padding-top: 1%;
}

.style-5 del{
    line-height: 0.5;
    display: block;
}

.style-5 .price{
    position: absolute;
    left: 86.5%;
    margin-left: 0;
    top: 45%;
    text-align: center;
}

@container (max-width: 100px) {
    .txt{
        font-size:0.8rem;
    }
}
.style-5 .txt-container{
    container-type: inline-size;
}

.style-5 .awards{
    max-width: 25%;
    padding-top: 3%;
    margin-left: 75%;
    height: 100%;
    background-image: linear-gradient(to right, rgb(208 85 23 / 50%), rgb(199 97 219 / 50%));
}


.style-5 .txt {
    color: #ffffe5;
    background: none;
}

.style-5 .time{
    top: 3%;
    font-weight: bold;
    font-size: 18px;
    left: 15px;
}
.style-5 .time img{

}

.style-5 .chk-btn{
    width: 200px;
    max-width: 95%;
}

.style-1{
    /*width:960px;
    height:336px;*/
    aspect-ratio: 1200/420;
}
.style-1 .title, .style-2 .title{
    width: 70%;
}
.style-2{
    /*width:960px;
    height:336px;*/
    padding-top: 40px;
    aspect-ratio: 1200/467;
}
.style-3{
    aspect-ratio: 1200/420;
}
.style-3 .price{
    position: absolute;
    display: block;
    top: 78%;
    right: 4.5%
}

.style-3 .title{
    height: 14%;
    padding-top: 1%;
}

.style-3 del{
    line-height: 0.5;
}




.style-2 .time{
    top: 60px;
}
.style-2 .price{
    margin-right: 50px;
}
.window{
    margin:auto;
    background-repeat: no-repeat;
    width:97.6px;
    height:66.4px;
    background-image: url('/images/store/window.png');
    text-align: center;
    background-size: contain;
    padding-top:10px;
    background-position: 20px;
}
.txt{
    color:#fff;
    text-align: center;
    margin:auto;
    line-height: 1;
    background: rgba(0,0,0,0.5);
}
.awards{
    max-width:60%;
    padding-top:8%;
    margin-left:10px;
}
.style-3 .awards{
    max-width:80%;
    margin-left: 85px;
    padding-top:7%;
}
.style-3 .r{
    
}
.award{
    width: fit-content;
}
.award-icon{
    max-width: 40%;
    margin: auto;
}

.style-3 .price del{
    display: block;
}

.price del {
    font-size:22px;
    color: #000;
}
</style>